const Avatar = (props) => {
  const { user, size, noBorder } = props;

  if (!user) return <></>;

  // const thumbUrl = user.avatar?.url || user.avatar?.thumb;
  const thumbUrl =
    typeof user?.avatar === "string"
      ? user?.avatar
      : user?.avatar?.url || user.avatar?.thumb;

  const className =
    size === "xs"
      ? "w-8 h-8"
      : size === "sm"
      ? "w-10 h-10"
      : size === "md"
      ? "w-12 h-12"
      : "w-[72px] h-[72px]";
  if (thumbUrl) {
    return (
      <img
        // src={user?.avatar?.url || user?.avatar?.thumb || "Avatar"}
        src={thumbUrl}
        alt={`${user?.firstName} ${user?.lastName}`}
        className={`${className} rounded-full m-auto object-cover ${
          noBorder ? "" : "border-2"
        } border-gray-100 dark:border-gray-800`}
      />
    );
  }

  return (
    <div
      className={`${className} rounded-full m-auto text-center flex items-center bg-brand-500 text-white ${
        noBorder ? "" : "border-2"
      } border-gray-100 dark:border-gray-800`}
    >
      <div
        className={`flex-1 font-medium uppercase text-${
          size === "xs"
            ? "xs"
            : size === "sm"
            ? "sm"
            : size === "md"
            ? "xl"
            : "3xl"
        }`}
      >
        {user?.firstName && user.firstName[0]}
        {user?.lastName && user.lastName[0]}
      </div>
    </div>
  );
};

export default Avatar;
